<script setup lang="ts">
import InterviewHeader from '../../../interview/components/dumb/InterviewHeader.vue'
import InterviewLayout from '../../../interview/components/dumb/InterviewLayout.vue'
import { c } from '../../../intl'

const props = defineProps<{
  brandImage: string | null
}>()
</script>
<template>
  <InterviewLayout v-if="brandImage">
    <template #header>
      <InterviewHeader :brand-image="props.brandImage" title="INTRO" />
    </template>
    <h1 class="thank-you">
      {{ c('interview_page.thank_you') }}
    </h1>
  </InterviewLayout>
  <h1 v-else class="thank-you">
    {{ c('interview_page.thank_you') }}
  </h1>
</template>
<style lang="postcss">
.thank-you {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: var(--attest-spacing-8);
  color: #036;
  font-weight: bolder;
  text-align: center;
}
</style>
